/**
 * @generated SignedSource<<6de0dd688ea1fc0668ff37767babb42e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UploadClientPortalLogoInput = {
  clientOrgId: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type uploadClientPortalLogoMutation$variables = {
  input: UploadClientPortalLogoInput;
};
export type uploadClientPortalLogoMutation$data = {
  readonly uploadClientPortalLogo: {
    readonly clientPortalConfig: {
      readonly portalLogoUrl: string | null;
    } | null;
  } | null;
};
export type uploadClientPortalLogoMutation = {
  variables: uploadClientPortalLogoMutation$variables;
  response: uploadClientPortalLogoMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UploadClientPortalLogoPayload",
    "kind": "LinkedField",
    "name": "uploadClientPortalLogo",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ClientPortalConfig",
        "kind": "LinkedField",
        "name": "clientPortalConfig",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "portalLogoUrl",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "uploadClientPortalLogoMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "uploadClientPortalLogoMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e8e602317dcea1f73a59351080900d2d",
    "id": null,
    "metadata": {},
    "name": "uploadClientPortalLogoMutation",
    "operationKind": "mutation",
    "text": "mutation uploadClientPortalLogoMutation(\n  $input: UploadClientPortalLogoInput!\n) {\n  uploadClientPortalLogo(input: $input) {\n    clientPortalConfig {\n      portalLogoUrl\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "d7cf1abc1c6b51fe9084d0909bc3ea37";

export default node;
